import {
  Box,
  Text,
  HStack,
  useBreakpointValue,
  VStack,
} from "@chakra-ui/react";
import { useInView } from "react-intersection-observer";

function Poem2025() {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const isDesktop = useBreakpointValue({ base: false, md: true });
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  if (isDesktop) {
    return (
      <HStack w="100%" h="100%" mt="5%" ref={ref}>
        {/* <Image
          objectFit="cover"
          borderColor="white"
          src="Images/lily.png"
          alt="lily of the valley"
          ml="5%"
          mt="5%"
          w="15%"
        /> */}
        <Box
          justifyContent="center"
          w="25%"
          p="4"
          h="100%"
          opacity={inView ? 1 : 0}
          transition="opacity 2s"
        >
          <Text w="100%" textAlign="center" mb="1">
            Approaching the first,
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            My heart starts to ponder,
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            The year past gone,
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            With all of its wonder.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            The ball had been a highlight,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Despite the interesting brats.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            But so too had the cafe,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            Home to the cutest cats.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            The market never failed to bring joy,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Always followed by bagels and coffee.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            But I couldn't forget the convocation,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            With won gifts and cake so chocolatey.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            My date so beautiful, her dress simply breathtaking;{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            She is the loveliest symphony.{" "}
          </Text>
        </Box>
        <Box
          justifyContent="center"
          w="25%"
          p="4"
          h="100%"
          opacity={inView ? 1 : 0}
          transition="opacity 2s"
        >
          <Text w="100%" textAlign="center" mb="1">
            We searched for the rats,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            In a trip that marked two years.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Then MUNI came and passed,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            Bringing my girl nothing but cheers.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Alas the summer arrived,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            With mountains separating us two.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            But with it came the bird dances,
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            Providing a truly unique view.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Then came pivotal trips,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Born out of desperate yearning.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            Missing my girl beyond measure,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            Wanting to reduce my heartburning.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            The cacophony of fireworks,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            The elegant dinners,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            The beautiful girl,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            Had become my fondest memories forever.
          </Text>
        </Box>
        <Box
          justifyContent="center"
          w="25%"
          p="4"
          h="100%"
          opacity={inView ? 1 : 0}
          transition="opacity 2s"
        >
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            A semester then began,
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Marked by a winning game.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            And visits to obtain malatang,
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            {" "}
            No food could ever be the same.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            Small bunnies were discovered,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Looking so cute and sweet.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            And the 29th was celebrated,
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            {" "}
            The prettiest birthday girl's treat.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            Imbeciles were dealt with,
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            Trying to teach us the register.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            And farms were visited,
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            {" "}
            Goats all over the pasture.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            A trip to throw axes,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Brought surprising revelations.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            And a quest to watch Star Wars,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            Ended years of frustration.{" "}
          </Text>
        </Box>{" "}
        <Box
          justifyContent="center"
          w="25%"
          p="4"
          h="100%"
          opacity={inView ? 1 : 0}
          transition="opacity 2s"
        >
          <Text w="100%" textAlign="center" mb="1">
            And finally came the market,
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            A yearly rejoicing.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            Sprinkled with trips to see the Shiba,
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            {" "}
            Truly the cake's icing.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            Though these moments were special,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Each one more than the last.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            They would be nothing without the princess,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            Her beauty and presence each easily surpass.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            Thank you for the year,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Bringing me so much joy,
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            I will never let you go,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            And I'll always be your cowboy.
          </Text>
        </Box>
        {/* <Image
            objectFit="cover"
            borderColor="white"
            src="Images/lily.png"
            alt="lily of the valley"
            mr="5%"
            w="15%"
          /> */}
      </HStack>
    );
  } else if (isMobile) {
    return (
      <VStack w="100%" h="100%" mt="5%" ref={ref}>
        <Box
          justifyContent="center"
          w="90%"
          p="4"
          h="100%"
          opacity={inView ? 1 : 0}
          transition="opacity 2s"
        >
          <Text w="100%" textAlign="center" mb="1">
            Approaching the first,
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            My heart starts to ponder,
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            The year past gone,
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            With all of its wonder.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            The ball had been a highlight,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Despite the interesting brats.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            But so too had the cafe,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            Home to the cutest cats.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            The market never failed to bring joy,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Always followed by bagels and coffee.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            But I couldn't forget the convocation,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            With won gifts and cake so chocolatey.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            My date so beautiful, her dress simply breathtaking;{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            She is the loveliest symphony.{" "}
          </Text>

          <Text w="100%" textAlign="center" mb="1">
            We searched for the rats,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            In a trip that marked two years.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Then MUNI came and passed,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            Bringing my girl nothing but cheers.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Alas the summer arrived,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            With mountains separating us two.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            But with it came the bird dances,
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            Providing a truly unique view.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Then came pivotal trips,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Born out of desperate yearning.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            Missing my girl beyond measure,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            Wanting to reduce my heartburning.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            The cacophony of fireworks,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            The elegant dinners,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            The beautiful girl,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            Had become my fondest memories forever.
          </Text>

          <Text w="100%" textAlign="center" mb="1">
            {" "}
            A semester then began,
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Marked by a winning game.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            And visits to obtain malatang,
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            {" "}
            No food could ever be the same.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            Small bunnies were discovered,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Looking so cute and sweet.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            And the 29th was celebrated,
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            {" "}
            The prettiest birthday girl's treat.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            Imbeciles were dealt with,
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            Trying to teach us the register.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            And farms were visited,
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            {" "}
            Goats all over the pasture.{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            A trip to throw axes,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Brought surprising revelations.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            And a quest to watch Star Wars,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            Ended years of frustration.{" "}
          </Text>

          <Text w="100%" textAlign="center" mb="1">
            And finally came the market,
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            A yearly rejoicing.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            Sprinkled with trips to see the Shiba,
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            {" "}
            Truly the cake's icing.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            Though these moments were special,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Each one more than the last.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            They would be nothing without the princess,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="8">
            Her beauty and presence each easily surpass.
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            Thank you for the year,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            Bringing me so much joy,
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            {" "}
            I will never let you go,{" "}
          </Text>
          <Text w="100%" textAlign="center" mb="1">
            And I'll shall be your cowboy.
          </Text>
        </Box>
      </VStack>
    );
  }

  return null;
}

export default Poem2025;
